export const tr = {
    adaptive: 'Uyarlanır',
    all: 'Tümü',
    'banner-sizes': 'Banner boyutları',
    categories: 'Kategoriler',
    formats: 'Formatlar',
    operators: 'Operatörler',
    'predictor-detailed-less': '< {sum}',
    'predictor-error': 'Tahmin geçici olarak geçersiz',
    'predictor-sum-from': '/ {sum}',
    'predictor-sum-less': 'of < {sum}',
    regions: 'Bölgeler',
    screens: 'Ekranlar',
    zones: 'Alanlar'
};
